import React from 'react';
import { Card } from '../components/ui';
import { Chip, MiniArea, useChartWidth } from '../components/charts';

export default function SubjectPerformance({ allSubjects, subjectMetric, setSubjectMetric, buildSubjectSeries, computeAverage }) {
  const width = useChartWidth(58); // 32+24 padding + border
  if (!allSubjects || allSubjects.length === 0) return null;
  return (
    <Card title="Ders Performansı">
      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <button onClick={() => setSubjectMetric('correct')} style={{ background: 'transparent', border: 'none', padding: 0 }}><Chip label="Doğru" active={subjectMetric === 'correct'} /></button>
        <button onClick={() => setSubjectMetric('wrong')} style={{ background: 'transparent', border: 'none', padding: 0 }}><Chip label="Yanlış" active={subjectMetric === 'wrong'} /></button>
        <button onClick={() => setSubjectMetric('net')} style={{ background: 'transparent', border: 'none', padding: 0 }}><Chip label="Net" active={subjectMetric === 'net'} /></button>
      </div>
      <div style={{ display: 'grid', gap: 12 }}>
        {allSubjects.map((name, index) => {
          const s = buildSubjectSeries(subjectMetric, name);
          const avg = computeAverage(s.values);
          const latest = s.values && s.values.length ? s.values[s.values.length - 1] : null;
          const prev = s.values && s.values.length > 1 ? s.values[s.values.length - 2] : null;
          const diff = (latest != null && prev != null) ? (latest - prev) : null;
          const palette = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4', '#84CC16', '#EC4899', '#F97316', '#22C55E'];
          const idx = index % palette.length;
          const accent = palette[idx];
          const betterWhenHigher = (subjectMetric !== 'wrong');
          const isUp = diff != null ? diff > 0 : null;
          const isGood = diff != null ? ((betterWhenHigher && isUp) || (!betterWhenHigher && !isUp)) : null;
          const trendColor = isGood == null ? '#64748b' : (isGood ? '#10B981' : '#EF4444');
          const arrow = isUp == null ? '' : (isUp ? '▲' : '▼');
          return (
            <div key={name} style={{ background: '#fff', border: '1px solid #eef2f7', borderLeft: `4px solid ${accent}`, borderRadius: 12, padding: 12, boxShadow: '0 1px 6px rgba(0,0,0,0.04)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '2px 0 8px 0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: accent, display: 'inline-block' }} />
                  <div style={{ fontWeight: 700 }}>{name}</div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <span style={{ padding: '4px 8px', borderRadius: 999, border: '1px solid #e5e7eb', fontSize: 12, color: '#334155', background: '#f8fafc' }}>
                    Son: {latest != null ? (subjectMetric === 'net' ? latest.toFixed(2) : Math.round(latest)) : '-'}
                  </span>
                  <span style={{ padding: '4px 8px', borderRadius: 999, border: '1px solid #e5e7eb', fontSize: 12, color: trendColor, background: '#f8fafc' }}>
                    {arrow} {diff != null ? (subjectMetric === 'net' ? Math.abs(diff).toFixed(2) : Math.abs(Math.round(diff))) : '-'}
                  </span>
                </div>
              </div>
              <MiniArea values={s.values} dates={s.dates} showAvg={true} avg={avg} width={width} color={accent} />
            </div>
          );
        })}
      </div>
    </Card>
  );
}
